import React, { lazy, Suspense } from "react";
import Sidebar from "../../Module/sidebar";
import { Route, Routes } from "react-router";

import { useSelector } from "react-redux";
import {
  ProductDevelopmentPanelEmpSidebarData,
  ProductDevelopmentPanelSidebarData,
} from "../../Module/productDevelopmentPanelSidebarData";
import Loading from "../../Component/Loading";

// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
/********************* VP OPERATIONS PANEL**********************/
const TechnicalSupport = React.lazy(
  () => import("../VpOperationsPanel/technicalSupport"),
);
const Chat = React.lazy(() => import("../TeacherPanel/chat"));
const CxoBatchWiseCount = React.lazy(
  () => import("../CXOPanel/cxoBatchWiseCount"),
);
const DatewiseCount = React.lazy(() => import("../Finance/datewiseCount"));
const RevenueDetails = React.lazy(() => import("../Finance/revenueDetails"));
const DoubtSolveReview = React.lazy(
  () => import("../AdminPanel/doubtSolveReview"),
);
const TransactionEdutech = React.lazy(
  () => import("../CXOPanel/transactionEdutech"),
);
const TransactionEdutechStudyMaterial = React.lazy(
  () => import("../CXOPanel/transactionEdutechStudyMaterial"),
);
const RegistrationDetails = React.lazy(
  () => import("../TechnicalSupportPanel/registrationDetails"),
);
/****************************************************************/
/********************* TEACHER TASK PANEL**********************/
const AddTeacherTask = React.lazy(
  () => import("../CategoryPanel/addTeacherTask"),
);
const EditDeleteTeacherTask = React.lazy(
  () => import("../CategoryPanel/editDeleteTeacherTask"),
);
const TeacherPerformance = React.lazy(
  () => import("../CXOPanel/teacherPerformance"),
);
/****************************************************************/
/******************DATA ENTRY PANEL***************** */
const CreateTopic = React.lazy(() => import("../DataEntryPanel/createTopic"));
const EditdeleteTopic = React.lazy(
  () => import("../DataEntryPanel/editDeleteTopic"),
);
const CreateSubTopic = React.lazy(
  () => import("../DataEntryPanel/createSubTopic"),
);
const EditDeleteSubTopic = React.lazy(
  () => import("../DataEntryPanel/editDeleteSubTopic"),
);
const CreateLecture = React.lazy(
  () => import("../DataEntryPanel/createLecture"),
);
const EditDeleteLecture = React.lazy(
  () => import("../DataEntryPanel/editDeleteLecture"),
);
const AddLiveVideoNew = React.lazy(
  () => import("../DataEntryPanel/addLiveVideoNew"),
);
const EditDeleteLiveVideoNew = React.lazy(
  () => import("../DataEntryPanel/editDeleteLiveVideoNew"),
);
const AddPremierVideo = React.lazy(
  () => import("../DataEntryPanel/addPremierVideo"),
);
const EditDeletePremierVideo = React.lazy(
  () => import("../DataEntryPanel/editDeletePremierVideo"),
);
const AddFreeUserVideo = React.lazy(
  () => import("../DataEntryPanel/addFreeUserVideo"),
);
const EditDeleteFreeUserVideo = React.lazy(
  () => import("../DataEntryPanel/editDeleteFreeUserVideo"),
);
const AddLiveRecordedVideo = React.lazy(
  () => import("../DataEntryPanel/addLiveRecordedVideo"),
);
const EditDeleteLiveRecordedVideo = React.lazy(
  () => import("../DataEntryPanel/editDeleteLiveRecordedVideo"),
);
const CopyRecordedLecture = React.lazy(
  () => import("../DataEntryPanel/copyRecordedLecture"),
);
const EditDeleteCopyRecordedLecture = React.lazy(
  () => import("../DataEntryPanel/editDeleteCopyRecordedLecture"),
);
const BatchClone = React.lazy(() => import("../AdminPanel/batchClone"));
const BatchCloneCopyLiveToLiveLecture = React.lazy(
  () =>
    import("../DataEntryPanel/CopyLiveToLiveLecture/batchCloneCopyLiveToLiveLecture"),
);
const CopyLiveToRecordedBatchRecordedLecture = React.lazy(
  () =>
    import("../DataEntryPanel/CopyLiveToRecordedLecture/copyLiveToRecordedBatchRecordedLecture"),
);
const CopyLiveToRecodedBatch = React.lazy(
  () => import("../DataEntryPanel/CopyLiveToRecorded/copyLiveToRecordedBatch"),
);
const CopyLiveToRecordedLecture = React.lazy(
  () =>
    import("../DataEntryPanel/CopyLiveToRecordedLecture/copyLiveToRecordedLecture"),
);
const CopyLiveToLiveLecture = React.lazy(
  () => import("../DataEntryPanel/CopyLiveToLiveLecture/copyLiveToLiveLecture"),
);
const CreateNotification = React.lazy(
  () => import("../DataEntryPanel/createNotification"),
);
const EditDeleteNotification = React.lazy(
  () => import("../DataEntryPanel/editDeleteNotification"),
);
const CreateAssignTeacher = React.lazy(
  () => import("../DataEntryPanel/createAssignTeacher"),
);
const EditDeleteAssignTeacher = React.lazy(
  () => import("../DataEntryPanel/editDeleteAssignTeacher"),
);
const AddPart = React.lazy(() => import("../DataEntryPanel/addPart"));
const CreateExamSet = React.lazy(
  () => import("../DataEntryPanel/createExamSet"),
);
const EditDeleteExamSet = React.lazy(
  () => import("../DataEntryPanel/editDeleteExamSet"),
);
const CopyExamSet = React.lazy(() => import("../DataEntryPanel/copyExamSet"));
const AssignQuestionToExamSet = React.lazy(
  () => import("../DataEntryPanel/assignQuestionToExamSet"),
);
const CreateQuestion = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/createQuestion"),
);
const AddQuestionsNo = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/addQuestionsNo"),
);
const AddQuestionsYes = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/addQuestionsYes"),
);
const QuestionEditor = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/questionEditor"),
);
const EditDeleteQuestion = React.lazy(
  () => import("../DataEntryPanel/editDeleteQuestion"),
);
const EditQuestion = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/editQuestion"),
);
const QuestionsOrder = React.lazy(
  () => import("../DataEntryPanel/setQuestionOrder"),
);
const TeacherSupport = React.lazy(
  () => import("../TechnicalSupportPanel/teacherSupport"),
);
const LiveClassSchedule = React.lazy(
  () => import("../DataEntryPanel/liveClassSchedule"),
);
const SyllabusDashboard = React.lazy(
  () => import("../DataEntryPanel/syllabusDashboard"),
);
const QuestionBankEditor = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/questionBankEditor"),
);
const EditDeleteQuestionBank = React.lazy(
  () => import("../DataEntryPanel/editDeleteQuestionBank"),
);
const ReplaceLecture = React.lazy(
  () => import("../DataEntryPanel/replaceLecture"),
);
const ImportQuestions = React.lazy(
  () => import("../DataEntryPanel/CreateQuestion/importQuestions"),
);
const CopyPackage = React.lazy(
  () => import("../DataEntryPanel/CopyPackage/copyPackage"),
);
const EditCopyPackage = React.lazy(
  () => import("../DataEntryPanel/CopyPackage/editCopyPackage"),
);
const CreateQuestionOfTheday = React.lazy(
  () =>
    import("../DataEntryPanel/CreateQuestionOfTheDay/createQuestionOfTheday"),
);
const EditQuestionOftheDay = React.lazy(
  () => import("../DataEntryPanel/CreateQuestionOfTheDay/editQuestionOftheDay"),
);
const MockTestResult = React.lazy(
  () => import("../DataEntryPanel/MockTestResult/MockTestResult"),
);
const CreateAppFeature = React.lazy(
  () => import("../DataEntryPanel/AppFeature/createAppFeature"),
);
const EditAppFeature = React.lazy(
  () => import("../DataEntryPanel/AppFeature/editAppFeature"),
);

const AddImportRecordedVideo = React.lazy(
  () => import("../DataEntryPanel/addImportRecordedVideo"),
);
const EditDeleteImportRecordedVideo = React.lazy(
  () => import("../DataEntryPanel/editDeleteImportRecordedVideo"),
);

const StudentMigration = React.lazy(
  () => import("../DataEntryPanel/StudentMigration/studentMigration"),
);

const LectureLinkManagement = React.lazy(
  () => import("../DataEntryPanel/LinkManagement/lectureLinkManagement"),
);

/**********************************************/

const AddTeachingHours = React.lazy(
  () => import("../DataEntryPanel/addTeachingHours"),
);
const EditDeleteTeachingHours = React.lazy(
  () => import("../DataEntryPanel/editDeleteTeachingHours"),
);
const CreateJobType = React.lazy(
  () => import("../DataEntryPanel/createJobType"),
);
const EditDeleteJobType = React.lazy(
  () => import("../DataEntryPanel/editDeleteJobType"),
);
const AddCareer = React.lazy(() => import("../DataEntryPanel/addCareer"));
const EditDeleteCareer = React.lazy(
  () => import("../DataEntryPanel/editDeleteCareer"),
);

/******************ADMIN***************** */
const CreateExam = React.lazy(() => import("../AdminPanel/createExam"));
const EditDeleteExam = React.lazy(() => import("../AdminPanel/editDeleteExam"));
const CreateSubExam = React.lazy(() => import("../AdminPanel/createSubExam"));
const EditDeleteSubExam = React.lazy(
  () => import("../AdminPanel/editDeleteSubExam"),
);
const CreateParentCourse = React.lazy(
  () => import("../AdminPanel/createParentCourse"),
);
const EditDeleteParentCourse = React.lazy(
  () => import("../AdminPanel/editDeleteParentCourse"),
);
const CreateExamSection = React.lazy(
  () => import("../../Module/ExamSection/createExamSection"),
);
const CreateLanguage = React.lazy(() => import("../AdminPanel/createLanguage"));
const EditDeleteLanguage = React.lazy(
  () => import("../AdminPanel/editDeleteLanguage"),
);
const CreateAssignExamStream = React.lazy(
  () => import("../AdminPanel/createAssignExamStream"),
);
const CreateSubject = React.lazy(() => import("../AdminPanel/createSubject"));
const EditDeleteSubject = React.lazy(
  () => import("../AdminPanel/editDeleteSubject"),
);
const CreateMainCategory = React.lazy(
  () => import("../AdminPanel/createMainCategory"),
);
const EditDeleteMainCategory = React.lazy(
  () => import("../AdminPanel/editDeleteMainCategory"),
);
const CreateSection = React.lazy(() => import("../AdminPanel/createSection"));
const EditDeleteSection = React.lazy(
  () => import("../AdminPanel/editDeleteSection"),
);
const CreateAssignBooks = React.lazy(
  () => import("../Publication/createAssignBooks"),
);
const EditDeleteAssignBooks = React.lazy(
  () => import("../Publication/editDeleteAssignBooks"),
);
const CreatePackage = React.lazy(
  () => import("../CategoryPanel/createPackage"),
);
const EditDeletePackage = React.lazy(
  () => import("../CategoryPanel/editDeletePackage"),
);
const CreatePackageExtend = React.lazy(
  () => import("../AdminPanel/createPackageExtend"),
);
const EditDeletePackageExtend = React.lazy(
  () => import("../AdminPanel/editDeletePackageExtend"),
);

const CreateTeacher = React.lazy(() => import("../AdminPanel/createTeacher"));
const EditDeleteTeacher = React.lazy(
  () => import("../AdminPanel/editDeleteTeacher"),
);
const CreateAssignUnits = React.lazy(
  () => import("../CategoryPanel/createAssignUnits"),
);
const EditDeleteAssignUnit = React.lazy(
  () => import("../CategoryPanel/editDeleteAssignUnit"),
);
const CreatePattern = React.lazy(() => import("../AdminPanel/createPattern"));
const EditDeletePattern = React.lazy(
  () => import("../AdminPanel/editDeletePattern"),
);
const CreateBbMeetingId = React.lazy(
  () => import("../AdminPanel/createBbMeetingId"),
);
const EditDeleteBbMeetingId = React.lazy(
  () => import("../AdminPanel/editDeleteBbMeetingId"),
);
const BindBBBMeeting = React.lazy(() => import("../AdminPanel/bindBBBMeeting"));
const BaseOfferDiscount = React.lazy(
  () => import("../AdminPanel/BaseOffer/baseOfferDiscount"),
);
const EditBaseOfferDiscount = React.lazy(
  () => import("../AdminPanel/BaseOffer/editBaseOfferDiscount"),
);
const CreateBasePrice = React.lazy(
  () => import("../AdminPanel/createBasePrice"),
);
const EditDeleteBasePrice = React.lazy(
  () => import("../AdminPanel/editDeleteBasePrice"),
);
const AddFixedDiscount = lazy(
  () => import("../AdminPanel/FixedDiscount/addFixedDiscount"),
);
const EditFixedDiscount = lazy(
  () => import("../AdminPanel/FixedDiscount/editFixedDiscount"),
);
const AddFreeYTLectures = React.lazy(
  () => import("../AdminPanel/FreeYTLectures/addFreeYTLectures"),
);
const EditFreeYTLectures = React.lazy(
  () => import("../AdminPanel/FreeYTLectures/editFreeYTLectures"),
);
const AddNewCategoryDesc = React.lazy(
  () => import("../AdminPanel/CategoryIncudeDesc/addNewCatDesc"),
);
const CopyCategoryInclude = React.lazy(
  () => import("../AdminPanel/CopyCategoryInclude/copyCategoryInclude"),
);
const EditDeleteCategoryInclude = React.lazy(
  () => import("../AdminPanel/CopyCategoryInclude/editDeleteCategoryInclude"),
);

const AddRecordedLectureInCourse = React.lazy(
  () => import("../AdminPanel/addRecordedLectureInCourse"),
);

const BatchAnalysis = React.lazy(() => import("../AdminPanel/batchAnalysis"));

/*********************************************************** */
const CreateUpcomingBatches = React.lazy(
  () => import("../AdminPanel/Upcoming_batches/CreateUpcomingBatches"),
);
const EditUpcomingBatches = React.lazy(
  () => import("../AdminPanel/Upcoming_batches/EditUpcomingBatches"),
);
const CreateAssignExam = React.lazy(
  () => import("../AdminPanel/createAssignExam"),
);
const GlobalSpecialDiscount = React.lazy(
  () => import("../ConfigurationData/globalSpecialDiscount"),
);
/*********************************************************** */

const ProductDevelopmentDashboard = () => {
  const { loginType } = useSelector((state) => ({
    loginType: state.Auth?.loginType,
  }));

  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2
            ? ProductDevelopmentPanelEmpSidebarData
            : ProductDevelopmentPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <Suspense
            fallback={
              <div className="border p-1">
                <Loading />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<TechnicalSupport />} />
              <Route path="technicalSupport" element={<TechnicalSupport />} />
              <Route path="/Chat" element={<Chat />} />
              <Route path="cxobatchwiseCount" element={<CxoBatchWiseCount />} />
              <Route path="datewiseCount" element={<DatewiseCount />} />
              <Route path="revenueDetails" element={<RevenueDetails />} />
              <Route path="doubtsolvereview" element={<DoubtSolveReview />} />
              <Route
                path="transactionEdutech"
                element={<TransactionEdutech />}
              />
              <Route
                path="transactionEdutechStudyMaterial"
                element={<TransactionEdutechStudyMaterial />}
              />
              <Route
                path="registrationDetails"
                element={<RegistrationDetails />}
              />
              <Route path="addTeacherTask" element={<AddTeacherTask />} />
              <Route
                path="editDeleteTeacherTask"
                element={<EditDeleteTeacherTask />}
              />
              <Route
                path="teacherPerformance"
                element={<TeacherPerformance />}
              />
              <Route path="createTopic" element={<CreateTopic />} />
              <Route path="editdeleteTopic" element={<EditdeleteTopic />} />

              <Route path="createSubTopic" element={<CreateSubTopic />} />
              <Route path="editDeleteLecture" element={<EditDeleteLecture />} />
              <Route path="createLecture" element={<CreateLecture />} />
              <Route
                path="editDeleteSubTopic"
                element={<EditDeleteSubTopic />}
              />
              <Route path="addLiveVideoNew" element={<AddLiveVideoNew />} />
              <Route path="addPremierVideo" element={<AddPremierVideo />} />
              <Route path="addFreeUserVideo" element={<AddFreeUserVideo />} />
              <Route
                path="editDeletePremierVideo"
                element={<EditDeletePremierVideo />}
              />
              <Route
                path="editDeleteFreeUserVideo"
                element={<EditDeleteFreeUserVideo />}
              />

              <Route
                path="addLiveRecordedVideo"
                element={<AddLiveRecordedVideo />}
              />
              <Route
                path="editDeleteLiveRecordedVideo"
                element={<EditDeleteLiveRecordedVideo />}
              />

              <Route path="syllabusDashboard" element={<SyllabusDashboard />} />

              <Route
                path="addImportRecordedVideo"
                element={<AddImportRecordedVideo />}
              />
              <Route
                path="editDeleteImportRecordedVideo"
                element={<EditDeleteImportRecordedVideo />}
              />

              <Route path="studentMigration" element={<StudentMigration />} />

              <Route
                path="lectureLinkManagement"
                element={<LectureLinkManagement />}
              />

              <Route
                path="copyRecordedLecture"
                element={<CopyRecordedLecture />}
              />
              <Route
                path="editDeleteCopyRecordedLecture"
                element={<EditDeleteCopyRecordedLecture />}
              />
              <Route path="batchClone" element={<BatchClone />} />
              <Route
                path="batchCloneCopyLiveToLiveLecture"
                element={<BatchCloneCopyLiveToLiveLecture />}
              />
              <Route
                path="copyLiveToRecordedBatchRecordedLecture"
                element={<CopyLiveToRecordedBatchRecordedLecture />}
              />
              <Route
                path="liveToRecorded"
                element={<CopyLiveToRecodedBatch />}
              />
              <Route
                path="liveToRecordedLecture"
                element={<CopyLiveToRecordedLecture />}
              />
              <Route
                path="liveToLiveLecture"
                element={<CopyLiveToLiveLecture />}
              />

              <Route
                path="createNotification"
                element={<CreateNotification />}
              />
              <Route
                path="editDeleteNotification"
                element={<EditDeleteNotification />}
              />

              <Route
                path="createAssignTeacher"
                element={<CreateAssignTeacher />}
              />
              <Route
                path="editDeleteAssignTeacher"
                element={<EditDeleteAssignTeacher />}
              />
              <Route path="addPart" element={<AddPart />} />

              <Route path="createExamSet" element={<CreateExamSet />} />
              <Route path="editDeleteExamSet" element={<EditDeleteExamSet />} />
              <Route path="copyExamSet" element={<CopyExamSet />} />
              <Route
                path="assignQuestionToExamSet"
                element={<AssignQuestionToExamSet />}
              />

              <Route path="createQuestion" element={<CreateQuestion />} />

              <Route path="addQuestionYes" element={<AddQuestionsYes />} />
              <Route path="addQuestionNo" element={<AddQuestionsNo />} />
              <Route path="questionEditor" element={<QuestionEditor />} />
              <Route
                path="questionBankEditor"
                element={<QuestionBankEditor />}
              />
              <Route
                path="editDeleteQuestion"
                element={<EditDeleteQuestion />}
              />
              <Route
                path="editDeleteQuestionBank"
                element={<EditDeleteQuestionBank />}
              />
              <Route path="editQuestion" element={<EditQuestion />} />
              <Route path="questionOrder" element={<QuestionsOrder />} />

              <Route path="addTeachingHours" element={<AddTeachingHours />} />
              <Route
                path="editDeleteTeachingHours"
                element={<EditDeleteTeachingHours />}
              />
              <Route path="teacherSupport" element={<TeacherSupport />} />

              <Route
                path="editDeleteLiveVideoNew"
                element={<EditDeleteLiveVideoNew />}
              />
              <Route path="replaceLecture" element={<ReplaceLecture />} />
              <Route path="chat" element={<Chat />} />
              <Route path="liveclassschedule" element={<LiveClassSchedule />} />
              <Route path="createJobType" element={<CreateJobType />} />
              <Route path="editDeleteJobType" element={<EditDeleteJobType />} />
              <Route path="addcareer" element={<AddCareer />} />
              <Route path="editdeletecareer" element={<EditDeleteCareer />} />

              <Route path="copyPackage" element={<CopyPackage />} />
              <Route path="editCopyPackage" element={<EditCopyPackage />} />
              <Route
                path="createQuestionOfTheday"
                element={<CreateQuestionOfTheday />}
              />
              <Route
                path="editQuestionOftheday"
                element={<EditQuestionOftheDay />}
              />
              <Route path="importQuestions" element={<ImportQuestions />} />
              <Route path="mockTestResult" element={<MockTestResult />} />
              <Route path="createAppFeature" element={<CreateAppFeature />} />
              <Route path="editAppFeature" element={<EditAppFeature />} />
              <Route
                path="createParentCourse"
                element={<CreateParentCourse />}
              />
              <Route
                path="editDeleteParentCourse"
                element={<EditDeleteParentCourse />}
              />
              <Route path="createExam" element={<CreateExam />} />
              <Route path="editDeleteExam" element={<EditDeleteExam />} />

              <Route path="createSubExam" element={<CreateSubExam />} />
              <Route path="editDeleteSubExam" element={<EditDeleteSubExam />} />
              <Route path="createLanguage" element={<CreateLanguage />} />
              <Route
                path="editDeleteLanguage"
                element={<EditDeleteLanguage />}
              />
              <Route path="createAssignExam" element={<CreateAssignExam />} />
              <Route path="createPackage" element={<CreatePackage />} />
              <Route
                path="createAssignExamStream"
                element={<CreateAssignExamStream />}
              />
              <Route path="createAssignBooks" element={<CreateAssignBooks />} />
              <Route
                path="EditDeleteAssignBooks"
                element={<EditDeleteAssignBooks />}
              />
              <Route path="createSubject" element={<CreateSubject />} />
              <Route path="editDeleteSubject" element={<EditDeleteSubject />} />
              <Route
                path="createMainCategory"
                element={<CreateMainCategory />}
              />
              <Route
                path="editDeleteMainCategory"
                element={<EditDeleteMainCategory />}
              />
              <Route path="createSection" element={<CreateSection />} />
              <Route path="editDeleteSection" element={<EditDeleteSection />} />
              <Route
                path="createPackageExtend"
                element={<CreatePackageExtend />}
              />
              <Route
                path="editDeletePackageExtend"
                element={<EditDeletePackageExtend />}
              />
              <Route path="editDeletePackage" element={<EditDeletePackage />} />
              <Route path="createTeacher" element={<CreateTeacher />} />
              <Route path="editDeleteTeacher" element={<EditDeleteTeacher />} />
              <Route path="createAssignUnits" element={<CreateAssignUnits />} />
              <Route path="batchAnalysis" element={<BatchAnalysis />} />
              <Route path="createBasePrice" element={<CreateBasePrice />} />
              <Route
                path="editDeleteBasePrice"
                element={<EditDeleteBasePrice />}
              />
              <Route
                path="editDeleteAssignUnit"
                element={<EditDeleteAssignUnit />}
              />
              <Route path="createPattern" element={<CreatePattern />} />
              <Route path="editDeletePattern" element={<EditDeletePattern />} />
              <Route path="createBbMeetingId" element={<CreateBbMeetingId />} />
              <Route
                path="editDeleteBbMeetingId"
                element={<EditDeleteBbMeetingId />}
              />
              <Route path="bindBBBMeeting" element={<BindBBBMeeting />} />
              <Route path="baseOfferDiscount" element={<BaseOfferDiscount />} />
              <Route
                path="editBaseOfferDiscount"
                element={<EditBaseOfferDiscount />}
              />

              <Route path="addFreeYTLectures" element={<AddFreeYTLectures />} />
              <Route
                path="editFreeYTLectures"
                element={<EditFreeYTLectures />}
              />
              <Route path="addNewCatDesc" element={<AddNewCategoryDesc />} />
              <Route
                path="/addRecordedLectureInCourse"
                element={<AddRecordedLectureInCourse />}
              />
              <Route
                path="/copyCategoryInclude"
                element={<CopyCategoryInclude />}
              />
              <Route
                path="/editDeleteCategoryInclude"
                element={<EditDeleteCategoryInclude />}
              />
              <Route
                path="UpcomingBatchesAdd"
                element={<CreateUpcomingBatches />}
              />
              <Route
                path="UpcomingBatchesEdit"
                element={<EditUpcomingBatches />}
              />
              <Route path="addFixedDiscount" element={<AddFixedDiscount />} />
              <Route path="editFixedDiscount" element={<EditFixedDiscount />} />

              <Route path="createExamSection" element={<CreateExamSection />} />
              <Route
                path="globalSpecialDiscount"
                element={<GlobalSpecialDiscount />}
              />
              <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
              <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
            </Routes>
          </Suspense>
        }
      </div>
    </div>
  );
};

export default ProductDevelopmentDashboard;
